import { GarageKeyType } from "src/components/UserAccount/shared/GarageKey";
import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { Person } from "Types/api/Person";

/**
 * This maps to the API endpoint /v2/deals/{uuid}/person/auth
 * it lets you both update the Person record *and* request a new PIN in a single step.
 */
export const personAuthRequest = actionCreator(
    "person/auth/request",
    (uuid: string, person: Person, sendPinTo: GarageKeyType) => ({
        uuid,
        person,
        sendPinTo,
    }),
    () => ({ route: API.Deal })
);

export const personAuthSuccess = actionCreator("person/auth/success", (person: Person) => ({ person }));

export const personAuthFailure = actionCreator("person/auth/failure", (message: string) => ({ message }));
